import React from 'react';
import { FaInstagram, FaLinkedinIn, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
		    return (
		        <footer className="footer-container">
		            <div className="footer-links">
	                <div className="footer-column">
	                    <h4>Quem Somos</h4>
	                    {/* Nossa História (temporariamente oculto nesta versão) */}
	                    <RouterLink to="/proposito">Propósito e Valores</RouterLink>
	                    <RouterLink to="/governanca">Governança e Compliance</RouterLink>
	                    <RouterLink to="/fale-conosco">Fale Conosco</RouterLink>
	                </div>
                <div className="footer-column">
                    <h4>O que Fazemos</h4>
                    <RouterLink to="/visao-geral">O Que Fazemos</RouterLink>
                    <RouterLink to="/#o-que-fazemos">Serviços</RouterLink>
                </div>
                <div className="footer-column">
                    <h4>Conteúdo & Inovação</h4>
                    <RouterLink to="/news">Notícias</RouterLink>
                    <RouterLink to="/#ciencia-tecnologia">Ciência & Tecnologia</RouterLink>
                </div>
                <div className="footer-column">
                    <h4>Legal</h4>
                    <RouterLink to="/politica-de-privacidade">Política de Privacidade</RouterLink>
                    <RouterLink to="/termos-de-uso">Termos de Uso</RouterLink>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            window.dispatchEvent(new Event('openCookieSettings'));
                        }}
                        className="footer-link-button"
                        type="button"
                    >
                        Gerenciar Cookies
                    </button>
                </div>
            </div>

		            <div className="footer-info-bar">
		                <div className="info-left">
		                    <p className="company-name">R5 Inteligência Digital</p>
                        <div className="company-address">
                            <p>Parque Tecnológico da UnB, Bloco H, 1º Andar</p>
                            <p>Asa Norte, Brasília/DF CEP: 70.910-900</p>
                        </div>
		                </div>
		                <div className="info-center social-icons">
		                    <a href="https://www.instagram.com/r5inteligenciadigital/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
		                    <a href="https://www.linkedin.com/company/103669965/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
		                    <a href="https://wa.me/5561982356730?text=Ol%C3%A1%2C%20R5%21" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
	                    <a href="mailto:contato@r5id.com.br" target="_blank" rel="noopener noreferrer"><FaEnvelope /></a>
	                </div>
	                <div className="info-right" />
            </div>

            <div className="footer-copyright">
                &copy; {new Date().getFullYear()} R5 Inteligência Digital. Todos os direitos reservados.
            </div>
        </footer>
    );
};

export default Footer;
